export default __webpack_public_path__ + "static/media/broadcast.7325ff2b.png";